<template>
  <div id="main">
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <!-- 查询表单 -->
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="标签编码" label-col-flex="60px">
              <a-input v-model="queryForm.tagCode" placeholder="请输入标签编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>

          <a-grid-item>
            <a-form-item label="标签名称" label-col-flex="60px">
              <a-input v-model="queryForm.tagName" placeholder="请输入标签名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="标签类型" label-col-flex="60px">
              <a-input v-model="queryForm.tagType" placeholder="请输入标签类型" class="input" allow-clear/>
            </a-form-item>
            <!-- TODO 暂未使用@Enlin-01 -->
<!--            <a-form-item label="标签类型" label-col-flex="60px">
              <a-select v-model="queryForm.tagType" placeholder="请选择标签类型" @change="()=>{console.log(queryForm.tagType)}">
                <a-option value="">全部</a-option>
                <a-option value="category">分类</a-option>
                <a-option value="priority">优先级</a-option>
                <a-option value="status">状态</a-option>
              </a-select>
            </a-form-item>-->
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <a-row :gutter="12">
              <a-col flex="75px">
                <a-button type="primary" @click="handleQuery" :loading="loading">
                  <template #icon>
                    <icon-search style="stroke: #fff"/>
                  </template>
                  搜索
                </a-button>
              </a-col>
              <a-col flex="65px">
                <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              </a-col>
              <a-col flex="65px">
                <a-button type="text " @click="()=>{collapsed = !collapsed}">
                  <template #icon>
                    <icon-down v-if="collapsed"/>
                    <icon-up v-else/>
                  </template>
                  {{ collapsed ? '展开' : '收起' }}
                </a-button>
              </a-col>
            </a-row>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="标签状态" label-col-flex="60px">
              <a-select v-model="queryForm.tagStatus" placeholder="请选择标签状态">
                <a-option :value="0">全部</a-option>
                <a-option :value="1">启用</a-option>
                <a-option :value="2">禁用</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
<!--          <a-grid-item>-->
<!--            <a-form-item label="创建时间" label-col-flex="60px">-->
<!--              <a-range-picker-->
<!--                  v-model="queryForm.createTimeRange"-->
<!--                  format="YYYY-MM-DD"-->
<!--                  :placeholder="['开始时间','结束时间']"-->
<!--              />-->
<!--            </a-form-item>-->
<!--          </a-grid-item>-->
        </a-grid>
      </a-form>
    </canvas-glass-card>
    <a-space />
    <canvas-glass-card title="问题标签列表" variant="light" :hoverable="false" class="table-card">

        <!-- 数据表格 -->
        <div class="table-wrapper">
          <a-table
              :columns="columns"
              :data="pagination.records"
              :pagination="false"
              :loading="loading"
              column-resizable
              stripe
              :bordered="{cell:true}"
          >
            <!-- <span>{{record}}</span> -->
            <template #tagColor="{ record }">
              <span v-if="record.tagColor" class="tag-color"
                  :style="{backgroundColor: record.tagColor}">{{ record.tagColor }}</span>
              <span v-else>-</span>
            </template>

            <template #tagStatus="{ record }">
              <a-tag :color="record.tagStatus === 1 ? 'green' : 'red'">
                {{ record.tagStatus === 1 ? '启用' : '禁用' }}
<!--                <span v-if="record.tagStatus === 1" class="status-enabled">启用</span>-->
<!--                <span v-else class="status-disabled">禁用</span>-->
              </a-tag>
            </template>

            <template #createTime="{ record }">
              {{ formatDate(record.createTime) }}
            </template>

            <template #updateTime="{ record }">
              {{ formatDate(record.updateTime) }}
            </template>

            <!-- 操作列 -->
            <!--          <template #actions="{ record }">-->
            <!--            <div class="table-actions">-->
            <!--              <a-button type="text" size="small" @click="handleEdit(record)">编辑</a-button>-->
            <!--              <a-button-->
            <!--                  type="text"-->
            <!--                  size="small"-->
            <!--                  :class="record.tagStatus === 1 ? 'status-disabled' : 'status-enabled'"-->
            <!--                  @click="handleToggleStatus(record)"-->
            <!--              >-->
            <!--                {{ record.tagStatus === 1 ? '禁用' : '启用' }}-->
            <!--              </a-button>-->
            <!--              <a-popconfirm-->
            <!--                  content="确定要删除这个标签吗？"-->
            <!--                  type="warning"-->
            <!--                  @ok="handleDelete(record)"-->
            <!--              >-->
            <!--                <a-button type="text" size="small" status="danger">删除</a-button>-->
            <!--              </a-popconfirm>-->
            <!--            </div>-->
            <!--          </template>-->
          </a-table>
        </div>

        <!-- 分页组件 -->
        <div class="pagination">
          <a-pagination
              style="justify-content: end;margin: 10px;"
              :total="pagination.total"
              v-model:current="pagination.current"
              v-model:page-size="pagination.size"
              show-total
              show-jumper
              show-page-size
              @change="handlePageChange"
              @page-size-change="handlePageSizeChange"
          />
        </div>
    </canvas-glass-card>
  </div>
</template>

<script>
import {getBaseDataIssueTagList} from "@/apis/base-data-api";
import {Message} from "@arco-design/web-vue";
import CanvasGlassCard from "@/components/CanvasGlassCard.vue";
import {IconSearch} from "@arco-design/web-vue/es/icon";
import { getDictDataOfIssueTagType } from "@/apis/system-data";
import {timestampNumber2dateString} from "@/utils/date-util";

export default {
  name: 'IssueLabel',
  components: {IconSearch, CanvasGlassCard},
  data() {
    return {
      // 条件查询表单数据
      queryForm: {
        // 标签编码
        tagCode: '',
        // 标签名称
        tagName: '',
        // 标签类型
        tagType: '',
        // 标签状态：1-启用，2-禁用
        tagStatus: '',
        // createTimeRange: []
      },
      // 条件查询表单折叠
      collapsed: true,
      // 数据表格列配置
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   width: 80,
        //   fixed: 'left'
        // },
        {
          title: '排序序号',
          dataIndex: 'sortOrder',
          width: 120,
          sortable: {
            sortDirections: ['ascend', 'descend']
          },
        },
        {
          title: '标签编码',
          dataIndex: 'tagCode',
          width: 120,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '标签名称',
          dataIndex: 'tagName',
          width: 150,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '标签类型',
          dataIndex: 'tagType',
          width: 120,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '标签颜色',
          dataIndex: 'tagColor',
          slotName: 'tagColor',
          width: 100
        },
        {
          title: '状态',
          dataIndex: 'tagStatus',
          slotName: 'tagStatus',
          width: 80
        },
        {
          title: '标签描述',
          dataIndex: 'tagDescription',
          ellipsis: true,
          tooltip: true,
          width: 200
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          slotName: 'createTime',
          width: 160,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          slotName: 'updateTime',
          width: 160,
          ellipsis: true,
          tooltip: true
        },
        // {
        //   title: '操作',
        //   slotName: 'actions',
        //   fixed: 'right',
        //   width: 180
        // }
      ],
      // 分页信息
      pagination: {
        records: [],
        current: 1,
        size: 10,
        pages: 0,
        total: 0
      },
      // 加载状态
      loading: false

    }
  },
  mounted() {
    this.fetchTableData();
    // TODO 暂未使用@Enlin-01 如果需要获取字典数据，请取消注释 
    // this.fetchTagTypeDictData();
  },
  methods: {
    // 获取表格数据
    fetchTableData() {
      this.loading = true;
      getBaseDataIssueTagList({
        ...this.queryForm,
        current: this.pagination.current,
        size: this.pagination.size
      }).then(response => {
        // console.log(response)
        this.loading = false;
        if (response.code === 0) {
          this.pagination = response.data;
        } else {
          Message.error(response.message);
        }
      }).catch(error => {
        Message.error(error.message)
      })

    },
    // 获取 标签类型 字典数据
    fetchTagTypeDictData() {
      getDictDataOfIssueTagType()
          .then(response => {
            if (response.code === 0) {
            } else {
              Message.error(response.message);
            }
          })
          .catch( error => {Message.error(error);})
    },
    // 处理查询
    handleQuery() {
      this.pagination.current = 1;
      this.fetchTableData();
    },

    // 处理重置
    handleReset() {
      this.queryForm = {
        tagCode: '',
        tagName: '',
        tagType: '',
        tagStatus: '',
        // createTimeRange: []
      };
      this.handleQuery();
    },

    // 处理页码变化
    handlePageChange(page) {
      console.log(page)
      this.fetchTableData();
    },

    // 处理每页数量变化
    handlePageSizeChange(pageSize) {
      this.pagination.current = 1;
      this.fetchTableData();
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '—';
      // return dateString.substring(0, 16).replace('T', ' ');
      return timestampNumber2dateString(dateString)
    },

    // 处理状态切换
    // handleToggleStatus(record) {
    //   this.$message.success(`已${record.tagStatus === 1 ? '禁用' : '启用'}标签：${record.tagName}`);
    // },

    // 处理删除
    // handleDelete(record) {
    //   this.$message.success(`已删除标签：${record.tagName}`);
    // },
  },
}
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}
</style>